import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { useViewport } from 'hooks/3catinfo/useViewport';
import { getUrlFriendly } from 'components/3catinfo/Enllac/RouteResolver';
import clsx from 'clsx';
import Boto from 'components/3catinfo/Boto';
import Enllac from 'components/3catinfo/Enllac';
import __isEmpty from 'lodash/isEmpty';
import Icona from '../ui/Icona';
import Modal from './Modal';
import styles from './compartir.module.scss';

const Compartir = ({
    className,
    mida,
    midaBoto,
    estil,
    estils,
    titol,
    mostraTwitter,
    mostraWhatsapp,
    mostraFacebook,
    mostraEnllac,
    route,
    obreEsquerra,
    titolCompartirMobil
}) => {
    const arrayEstils = estils?.split(' ') || [];
    const router = useRouter();
    const { isMobileDevice, zoomNavigator, isOnlyMobile } = useViewport();
    const [showModal, setShowModal] = useState(false);
    const [isTancat, setIsTancat] = useState(true);
    const [isModalInteractive, setIsModalInteractive] = useState(false);
    const [isCopyingLink, setIsCopyingLink] = useState(false);
    const timerCopyLink = useRef(null);
    const modalRef = useRef(null);
    const compartirBtnRef = useRef(null);

    const stylesCompartir = clsx({
        [styles.compartir]: true,
        [styles[estil]]: !!estil,
        [styles.esquerra]: obreEsquerra,
        [className]: !__isEmpty(className),
        [styles[midaBoto]]: !!midaBoto,
        ...arrayEstils.reduce((acc, currentStyle) => {
            acc[styles[currentStyle]] = !__isEmpty(currentStyle);
            return acc;
        }, {})
    });

    const stylesBtnCopiarEnllac = clsx({
        [styles.btn_copia]: true,
        [styles.copiant]: isCopyingLink
    });

    const stylesModalOverlay = clsx({
        [styles.overlay]: true,
        [styles.tancat]: isTancat,
        [styles.interactiu]: isModalInteractive,
        [styles.ambZoom]: isOnlyMobile && zoomNavigator > 2
    });

    const toggleModalHandler = async (url) => {
        if (navigator.share && isMobileDevice) {
            try {
                await navigator.share({
                    title: titolCompartirMobil,
                    text: titolCompartirMobil,
                    url
                });
            } catch (error) {
                console.error('Error al compartir:', error);
            }
        } else {
            if (!showModal) {
                setShowModal(true);
                setTimeout(() => setIsTancat(false), 0);
                setTimeout(() => setIsModalInteractive(true), 300);
            } else {
                setIsTancat(true);
                setIsModalInteractive(false);
                setTimeout(() => setShowModal(false), 300);
            }
        }
    };

    const handleClickCopyLink = () => {
        if (!isCopyingLink) {
            navigator.clipboard.writeText(url);
            setIsCopyingLink(true);
            timerCopyLink.current = null;
            timerCopyLink.current = setTimeout(() => {
                setIsCopyingLink(false);
            }, 5000);
        }
    };

    const _getCanal = (canals) => {
        const c = canals.canal ? canals.canal : canals;
        const canalMain = c.find((canal) => canal.main === true);
        return canalMain?.desc || c?.[0]?.desc || 'sense';
    };

    const _getUrl = (route) => {
        if (route.href) return route.href;
        const canalMain = route?.canals ? _getCanal(route.canals) : 'sense';
        return getUrlFriendly({ ...route, routePath: route?.type, canal: canalMain, producte: 'web_noticies' });
    };

    const titolAudiencies = !__isEmpty(titol) ? titol.replace(':', '.') : route?.slug;

    const url = __isEmpty(route) ? 'https://www.3cat.cat' + router.asPath : 'https://www.3cat.cat' + _getUrl(route);

    const hitAudiencies = (type) => {
        const xarxa = type || 'XS desconeguda';
        _satellite?.track('scCompartir', { xarxaAccioContingut: xarxa + titolAudiencies });
    };

    useEffect(() => {
        if (!showModal) {
            timerCopyLink.current = null;
            setIsCopyingLink(false);
        }
    }, [showModal]);

    /*const handleClickOutside = ({ target }) => {
        if (modalRef.current && !modalRef?.current?.contains(target) && !compartirBtnRef?.current?.contains(target)) {
            setShowModal(false);
        }
    };*/

    /*useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);*/

    return (
        <div className={stylesCompartir} data-testid={'boto-compartir'}>
            <button
                className={styles.boto}
                onClick={() => {
                    toggleModalHandler(url);
                }}
                aria-expanded={showModal}
                aria-label='Comparteix'
                ref={compartirBtnRef}
                data-type='compartir'
            >
                <Icona
                    inline={true}
                    mida={mida}
                    className={styles.icona}
                    isBlanc={estil === 'negatiu' || arrayEstils.includes('negatiu')}
                    icona={showModal ? 'tanca' : 'compartir'}
                    alt='Compartir'
                />
            </button>
            <div ref={modalRef}>
                <Modal isOpen={showModal}>
                    <ul className={stylesModalOverlay}>
                        {mostraEnllac && (
                            <li>
                                <Boto
                                    tag='button'
                                    text={isCopyingLink ? 'Copiat!' : "Copia l'enllaç"}
                                    estil='transparent'
                                    icona={isCopyingLink ? 'checked_contorn_cercle' : 'enllac'}
                                    isIconaDreta={false}
                                    isIconaBlanc={true}
                                    iconaInline={true}
                                    mida={24}
                                    className={stylesBtnCopiarEnllac}
                                    fons={estil !== 'negatiu' || 'fonsContenidorNegre'}
                                    onClick={handleClickCopyLink}
                                />
                            </li>
                        )}
                        {mostraTwitter && (
                            <li>
                                <button
                                    onClick={() => {
                                        const cadena =
                                            'https://twitter.com/intent/tweet?text=' +
                                            titol +
                                            '&url=' +
                                            url +
                                            '?ext=SM_TW_F4_CE24_';
                                        window.open(cadena, 'Twitter', 'toolbar=0, status=0, width=550, height=500');
                                        hitAudiencies('Twitter:share:');
                                    }}
                                    href={'https://twitter.com/intent/tweet?text=' + titol + '&url=' + url}
                                    className={styles.link}
                                >
                                    <Icona
                                        icona='x'
                                        inline={true}
                                        isBlanc={true}
                                        className={styles.iconaSocial}
                                        alt='X'
                                        role='img'
                                    />
                                </button>
                            </li>
                        )}
                        {mostraFacebook && (
                            <li>
                                <button
                                    onClick={() => {
                                        const cadena =
                                            'https://www.facebook.com/sharer/sharer.php?u=' + url + '?ext=SM_FB_F4_CE24_';
                                        window.open(cadena, 'Facebook', 'toolbar=0, status=0, width=550, height=500');
                                        hitAudiencies('Facebook:share:');
                                    }}
                                    className={styles.link}
                                >
                                    <Icona
                                        icona='facebook_rodona'
                                        inline={true}
                                        isBlanc={true}
                                        className={styles.iconaSocial}
                                        alt='Facebook'
                                        role='img'
                                    />
                                </button>
                            </li>
                        )}
                        {mostraWhatsapp && (
                            <li>
                                <Enllac
                                    href={'https://wa.me/?text=' + url + '?ext=SM_WP_F4_CE24_'}
                                    onClick={() => {
                                        hitAudiencies('Whatsapp:share:');
                                    }}
                                    className={styles.link}
                                    data-action='share/whatsapp/share'
                                    target='_blank'
                                >
                                    <Icona
                                        icona='whatsappGran'
                                        inline={true}
                                        isBlanc={true}
                                        className={styles.iconaSocial}
                                        alt='Whatsapp'
                                        role='img'
                                    />
                                </Enllac>
                            </li>
                        )}
                    </ul>
                </Modal>
            </div>
        </div>
    );
};

Compartir.defaultProps = {
    mida: '20',
    titol: '',
    mostraTwitter: true,
    mostraWhatsapp: true,
    mostraFacebook: true,
    mostraEnllac: true,
    obreEsquerra: false,
    titolCompartirMobil: ''
};

export default React.memo(Compartir);
